/// <amd-module name="Artifacts/Pypi/components/PypiPackageOverview" />
import { PackageDeletedMessageCard } from "Artifacts/Package/components/package-details-common/PackageDeletedMessageCard";
import { PackageTile } from "Artifacts/Package/components/package-details-common/PackageTile";
import * as PackageRes from "Artifacts/Package/Resources";
import { PypiDescription } from "Artifacts/Pypi/components/PypiDescription";
import { getCopyInstallCommand } from "Artifacts/Pypi/helpers/InstructionsHelper";
import { IPyPiProtocolMetadata } from "Artifacts/Pypi/IPyPiProtocolMetadata";
import * as PyPiRes from "Artifacts/Pypi/Resources";
import { IPyPiRestApiUrlGeneratorService } from "Artifacts/Pypi/services/PyPiRestApiUrlGeneratorService";
import { CopyableTextField } from "Artifacts/Root/protocols/components/CopyableTextField";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as RootRes from "Artifacts/Root/Resources";
import { connectToFeed } from "Artifacts/Root/routing/Constants";
import { IFeed } from "Artifacts/Root/types/IFeed";
import { IPackage } from "Artifacts/Root/types/IPackage";
import { IPackageVersion } from "Artifacts/Root/types/IPackageVersion";
import * as React from "react";
import { generatePath, useHistory } from "react-router-dom";
import { IVssPageContext } from "VSS/Platform/Context";
import { useComponentContext } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { ISimpleListCell, SimpleList } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";

const PypiOverview: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const history = useHistory();
  const { pageContext } = useComponentContext();

  const pypiMetadata =
    version.protocolMetadata && version.protocolMetadata.data
      ? (version.protocolMetadata.data as IPyPiProtocolMetadata)
      : ({} as IPyPiProtocolMetadata);

  const command = getCopyInstallCommand(pkg.name, version);

  return (
    <div className="package-overview-content">
      {version.isDeleted && (
        <PackageDeletedMessageCard version={version.version} packageName={pkg.name} />
      )}
      {!version.isDeleted && (
        <PackageTile title={PackageRes.PackageDetails_GetThisPackage}>
          <div className="package-command">
            <Button
              iconProps={{
                iconName: "PlugConnected",
              }}
              onClick={() => {
                feed && history.push(generatePath(connectToFeed, { feedIdentifier: feed.name }));
              }}
            >
              {RootRes.ConnectToFeedButton}
            </Button>
            <span className="install-instructions-then">
              {PackageRes.PackageDetails_InstallInstructions_then}
            </span>
            <CopyableTextField text={command}></CopyableTextField>
          </div>
        </PackageTile>
      )}

      {version.description && (
        <PackageTile title={PyPiRes.Summary}>
          <div className="package-description">{version.description}</div>
        </PackageTile>
      )}

      {!version.isDeleted && version.files && version.files.length && (
        <PackageTile title={PyPiRes.Files}>
          <SimpleList
            itemProvider={
              new ArrayItemProvider<ISimpleListCell>(
                version.files.map((f) => renderFile(pageContext, feed, pkg, version, f.name)),
              )
            }
          />
        </PackageTile>
      )}
      {pypiMetadata.description && pypiMetadata.descriptionContentType && (
        <PypiDescription
          description={pypiMetadata.description}
          contentType={pypiMetadata.descriptionContentType}
        />
      )}
    </div>
  );
};

function renderFile(
  pageContext: IVssPageContext,
  feed: IFeed,
  pkg: IPackage,
  version: IPackageVersion,
  filename: string,
): ISimpleListCell {
  return {
    href: pageContext
      .getService<IPyPiRestApiUrlGeneratorService>("IPyPiRestApiUrlGeneratorService")
      .getFileDownloadUrl(
        feed,
        pkg.name,
        version.normalizedVersion,
        filename,
        feed.accountMetadata.publicAccessMapping,
      ),
    textClassName: "package-link-text",
    hrefRel: "noopener noreferrer",
    text: filename,
  } as ISimpleListCell;
}

export { PypiOverview };
